import * as Notifications from 'expo-notifications';
import { useState } from 'react';

const useNotifications = () => {
    const [ permission, setPermission ] = useState<Notifications.NotificationPermissionsStatus | undefined>(undefined);
    const [ expo_token, setExpoToken ] = useState<Notifications.ExpoPushToken | undefined>(undefined);
    const [ push_token, setPushToken ] = useState<Notifications.DevicePushToken | undefined>(undefined);
    const getPermission = async():Promise<Notifications.NotificationPermissionsStatus | undefined> => {
        try {
            const resp = await Notifications.getPermissionsAsync();
            setPermission(resp);
            return resp
        } catch (e) {
            console.log('hey')
            return undefined
        }
    }

    const requestPermission = async():Promise<Notifications.NotificationPermissionsStatus | undefined> => {
        try {
            const resp = await Notifications.requestPermissionsAsync();
            setPermission(resp);
            return resp
        } catch (e) {
            console.log('error')
            return undefined
        }
    }
    
    const getMyToken = async():Promise<Notifications.DevicePushToken | undefined> => {
        try {
            const resp = await Notifications.getDevicePushTokenAsync();
            setPushToken(resp)
            return resp
        } catch (e) {
            console.log('Hey')
            return undefined
        }
    }

    const getMyExpoToken = async() => {
        try {
            const resp = await Notifications.getExpoPushTokenAsync({
                projectId: 'f5c1b873-aa91-4e4c-9637-266d0675796d'
            });
            console.log(resp)
            setExpoToken(resp)
            return resp
        } catch (e) {
            
            return undefined
        }
    }
    return { permission, push_token, expo_token, getMyExpoToken, getMyToken, getPermission, requestPermission }
}

export { useNotifications }